// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"9b2837db","526":"458ccb54","785":"a32bec2c"}[chunkId] + ".chunk.js";
};